import { SideDrawer } from '@sales-center/components'
import * as React from 'react'

import { FormFieldWrapper } from './FormFields'
import type { CustomFieldFormProps } from './typings'

export function CustomFieldForm(props: CustomFieldFormProps) {
  const { open, onClose, initialValues } = props

  const title = `${!!initialValues ? 'Update' : 'Create'} Custom Field`

  return (
    <SideDrawer title={title} open={open} onClose={onClose}>
      <FormFieldWrapper {...props} />
    </SideDrawer>
  )
}
